import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import Reprint from "@/pages/Reprint.vue";
import Shelve from "@/pages/Shelve.vue";
import Empty from "@/pages/Empty.vue";
import Barcodes from "@/pages/Barcodes.vue";
import Display from "@/pages/Display.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "reprint",
        name: "reprint",
        component: Reprint
      },
      {
        path: "shelve",
        name: "shelve",
        component: Shelve
      },
      {
        path: "empty",
        name: "empty",
        component: Empty
      },
      {
        path: "barcodes",
        name: "barcodes",
        component: Barcodes
      },
      {
        path: "display",
        name: "display",
        component: Display
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
